import React from 'react';
import { ComponentWithAs, Flex, FlexProps, forwardRef } from '@chakra-ui/react';
import RecommendButton from '../../common/molecule/RecommendButton';
import FilterLink from '../molecule/FilterLink';

const HomeNavigationSection: ComponentWithAs<'div', FlexProps> = forwardRef<FlexProps, 'div'>(
  (props, ref) => {
    return (
      <Flex pb={24} align='center' justify='center' direction='column' ref={ref} {...props}>
        <RecommendButton text='추천받기' variant='primary' size='lg' />
        <FilterLink py={2} />
      </Flex>
    );
  },
);

export default HomeNavigationSection;
